export const LP_URL = '/jobma/client/';
export const STATION_URL = '/jobma/client/order/station';
export const TYPE_URL = '/jobma/client/order/type';
export const SKILL_URL = '/jobma/client/order/skill';
export const COND_URL = '/jobma/client/order/cond';
export const INFO_URL = '/jobma/client/order/info';
export const CONF_URL = '/jobma/client/order/conf';
export const THANKS_URL = '/jobma/client/order/thanks';
export const FIRST_URL = '/jobma/client/order/station';
export const EKI_SUGGEST_PATH = '/v1/jobsearch/ekisuggest';
export const HOURSALARY_SUGGEST_PATH = '/v1/getHourSalary';
export const ADD_SEARCH_PATH = '/v1/addresses/search';
export const REGISTER_ORDER_PATH = '/v1/registerOrder';
export const CHECK_EKICODE_PATH = '/v1/checkEkiCode';

export const BUTTON_NO_PREV = 'BUTTON_NO_PREV';
export const BUTTON_DEFAULT = 'BUTTON_DEFAULT';
export const BUTTON_SUBMIT = 'BUTTON_SUBMIT';
export const BUTTON_BACKLP = 'BUTTON_BACKLP';
export const ROOT_ELEMENT_ID = 'root';

export const CHOICES_NAME_MAP = {
  ekiName: '最寄り駅',
  moveTime: '所要時間',
  moveTimeFromBusStop: 'バス停からの所要時間',
  otherWorkText: 'その他',
  qualificationText: 'その他資格',
  corpName: '会社名',
  facilityName: '施設名',
  userName: 'ご担当者名',
  tel: '電話番号',
  email: 'メールアドレス',
  emailConf: 'メールアドレス(確認)',
  dayOfTheWeek: '就業曜日',
  workStyleKbn: 'シフト区分',
  hourSalary: '金額',
  freeComment: 'その他条件',
  facilityType: '施設種類',
  capacity: '定員規模',
  zip: '郵便番号',
  municipality: '市区町村',
  houseNumber: '番地以降',
};

// エラーメッセージ定義
export const ERROR_MESSAGES = [
  { pattern: /^should NOT be shorter than 1 characters/, label: 'を入力してください' },
  { pattern: /^should NOT be longer than/, label: 'の入力内容が長すぎます' },
  { pattern: /^should match pattern/, label: 'の入力内容が不正です' },
  { pattern: /^should NOT have fewer than 1 items/, label: 'を選択してください' },
  { pattern: /^should NOT have more than 5 items/, label: 'は最大5つまでです' },
  { pattern: /^should match "else" schema/, label: 'の入力内容が不正です' },
  { pattern: /^xss error/, label: '特殊文字（例: 髙、<、>、① ）が含まれています。別の文字に置き換えてください。' },
];
export const NO_NAME_ERROR_MESSAGES = [
  '特殊文字（例: 髙、<、>、① ）が含まれています。別の文字に置き換えてください。'
];
export const SUCCESS_MESSAGES = {
  checkEkiCodeOK: 'サービス対象エリアです',
};
export const CUSTOM_ERROR_MESSAGES = {
  ekiSuggestZero: '該当する駅が見つかりません',
  checkEkiCodeNG: 'サービス対象外エリアです',
  qualificationsNG: '介護資格を選択するか、入力してください',
  syuugyouKikanNG: '期間の入力内容が不正です',
  syuugyouKikan31NG: '期間は31日以上を設定してください',
  syuugyouTimeNG: '就業時間の入力内容が不正です',
  overTimeNG: '残業時間/月の入力内容が不正です',
  dayOfTheWeekNG: '就業曜日の数が就業日数/週を下回っています',
  over8HoursNG: '就業時間が8時間を超えています',
  week20hourNG: '日雇い派遣に該当するため、労働時間は週に20時間以上に設定してください',
  restTimeNG: '労働時間が6時間を超える場合、45分以上の休憩が必要です',
  businessDayNG: '就業日数/週の入力内容が不正です',
  emailConfNG: 'メールアドレスとメールアドレス(確認)が一致しません。',
  hourSalaryWarn: '請求金額が相場より低いためみつかりにくい可能性があります',
};
export const FATAL_ERROR = 'JBM_FATAL_ERROR';
export const FATAL_ERROR_MESSAGES = [
  '予期せぬエラーが発生しました。',
  '申し訳ありませんが、しばらくたってから再度実行してください。',
];
export const DROPDOWN_INITIAL_ITEM = { value: '', label: '選択する' }; // labelが空だと画面が崩れる

// ナビの吹き出し文言
export const NAVI_NOTICE_MAP = {
  title: 'こちらで請求金額の確認ができます',
  notice: [
    '<u>STEP2</u>までの質問にご回答いただくと',
    'ご入力内容を基に平均相場を自動算出します。',
  ],
};

// 確認画面 モーダル内テキスト
export const ACKNOWLEDGE_MAP = {
  title: '依頼を完了する前に必ずご確認ください',
  notice: [
    '1. 依頼後、派遣契約締結前に契約に必要な詳細情報をお伺いします。',
    '2. 派遣契約の締結をもって正式な契約成立となります。',
    '3. 人材決定後のキャンセルはできませんのでご留意ください。',
  ],
  judges: [ 
    '※Jobマ!は人材派遣サービスとなります。そのため、派遣法に則り人材の選考・特定行為は禁止となりますのであらかじめご了承ください。',
    '※新規お取引の企業様の場合は、事前審査を実施させていただきます。人選開始は事前審査を通過した場合のみとさせていただきます。また、事前審査を通過後、お支払い条件をご相談させていただく場合がございます。あらかじめご了承ください。', 
  ],
};

// サンクス画面内のテキスト
export const THANKS_TEXT = {
  Orei: [ '人材発注の受付が完了いたしました。', '内容確認後、ご登録いただいたメールアドレスへご連絡いたします。' ],
  BoxTitle: '今後の流れ',
  leftSubTitle: '人材のご紹介',
  leftDetail: 'ご依頼内容をもとに人材をご紹介します。',
  leftAnnotationText: [ '人選完了後、人材をご紹介します。', 'ご紹介した人材の希望により、施設ご担当者様、ご紹介した人材、弊社担当の三者間で業務内容の確認を行います。', 
    'Jobマ!ではスピードを重視するため、業務内容の確認はメール or チャットで行います。' ],
  leftAsteriskText: '※人材決定後のキャンセルはできませんのでご留意ください。',
  rightSubTitle: '就業開始',
  rightDetail: '依頼から最短1営業日で就業開始が可能です。',
  rightAnnotationText: [ '就業初日はご紹介した人材が就業場所に伺います。', '関係者へのご紹介や施設案内、業務内容や職場でのルールの説明をお願いします。', 'ご不明点がありましたら弊社までお気軽にご連絡ください。' ],

};

export const CHOICES_MAP = {
  moveTypeCdList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '1', label: '徒歩' },
    { value: '2', label: 'バス' },
    { value: '3', label: '車' },
  ],
  TypeTitleList: [ 'physicalCareList', 'lifeSupportList' ],
  physicalCareList: [
    { value: '01', label: '入浴介助' },
    { value: '02', label: '排泄介助' },
    { value: '03', label: '食事介助' },
    { value: '04', label: '移動補助' },
    { value: '05', label: '更衣介助' },
  ],
  lifeSupportList: [
    { value: '01', label: '洗濯' },
    { value: '02', label: '清掃' },
    { value: '03', label: '調理' },
    { value: '04', label: '配膳下膳' },
    { value: '05', label: '送迎' },
  ],

  experienceList: [
    { value: '01', label: '不問', salary: 0 },
    { value: '02', label: 'あり', salary: 50 },
  ],
  qualificationList: [
    { value: '01', label: '不問', salary: -110, experience: false },
    { value: '02', label: '介護職員初任者研修', salary: 60, experience: false },
    { value: '03', label: '介護職員実務者研修', salary: 80, experience: true },
    { value: '04', label: 'ケアマネージャー（介護支援専門員）', salary: 80, experience: true },
    { value: '05', label: '介護福祉士', salary: 200, experience: true },
  ],
  workStyleList: [
    { value: '02', label: 'シフト勤務' },
    { value: '01', label: '固定勤務' },
  ],
  minBusinessDayList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '5', label: '5' },
    { value: '4', label: '4' },
    { value: '3', label: '3' },
    { value: '2', label: '2' },
    { value: '1', label: '1' },
  ],
  maxBusinessDayList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '5', label: '5' },
    { value: '4', label: '4' },
    { value: '3', label: '3' },
    { value: '2', label: '2' },
    { value: '1', label: '1' },
  ],
  dayOfTheWeekList: [
    { value: '1', label: '月' },
    { value: '2', label: '火' },
    { value: '3', label: '水' },
    { value: '4', label: '木' },
    { value: '5', label: '金' },
    { value: '6', label: '土' },
    { value: '0', label: '日' },
  ],
  workStyleKbnList: [
    { value: '02', label: '早番' },
    { value: '03', label: '日勤' },
    { value: '04', label: '遅番' },
    { value: '05', label: '夜勤' },
  ],
  startHourList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '00', label: '00' },
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
  ],
  startMinList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '00', label: '00' },
    { value: '05', label: '05' },
    { value: '10', label: '10' },
    { value: '15', label: '15' },
    { value: '20', label: '20' },
    { value: '25', label: '25' },
    { value: '30', label: '30' },
    { value: '35', label: '35' },
    { value: '40', label: '40' },
    { value: '45', label: '45' },
    { value: '50', label: '50' },
    { value: '55', label: '55' },
  ],
  endHourList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '00', label: '00' },
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
  ],
  endMinList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '00', label: '00' },
    { value: '05', label: '05' },
    { value: '10', label: '10' },
    { value: '15', label: '15' },
    { value: '20', label: '20' },
    { value: '25', label: '25' },
    { value: '30', label: '30' },
    { value: '35', label: '35' },
    { value: '40', label: '40' },
    { value: '45', label: '45' },
    { value: '50', label: '50' },
    { value: '55', label: '55' },
  ],
  restTimeList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '0', label: '0' },
    { value: '15', label: '15' },
    { value: '30', label: '30' },
    { value: '45', label: '45' },
    { value: '60', label: '60' },
    { value: '75', label: '75' },
    { value: '90', label: '90' },
    { value: '105', label: '105' },
    { value: '120', label: '120' },
  ],
  canCommuteByCarList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '01', label: '可' },
    { value: '02', label: '不可' },
  ],

  facilityTypeList: [
    { value: '01', label: '特別養護老人ホーム' },
    { value: '02', label: '有料老人ホーム' },
    { value: '03', label: '老人保護施設' },
    { value: '04', label: 'ケアハウス' },
    { value: '05', label: 'ショートステイ' },
    { value: '06', label: 'デイサービス' },
    { value: '07', label: 'サービス付高齢者住宅' },
    { value: '08', label: '養護老人ホーム' },
    { value: '09', label: 'グループホーム' },
    { value: '10', label: '小規模多機能型居宅介護' },
    { value: '11', label: '障がい者施設' },
    { value: '12', label: 'その他' },
  ],
  capacityList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '01', label: '1～9名' },
    { value: '02', label: '10～19名' },
    { value: '03', label: '20～29名' },
    { value: '04', label: '30～39名' },
    { value: '05', label: '40～49名' },
    { value: '06', label: '50～59名' },
    { value: '07', label: '60～69名' },
    { value: '08', label: '70～79名' },
    { value: '09', label: '80～89名' },
    { value: '10', label: '90～99名' },
    { value: '11', label: '100～109名' },
    { value: '12', label: '110～119名' },
    { value: '13', label: '120～129名' },
    { value: '14', label: '130～139名' },
    { value: '15', label: '140～149名' },
    { value: '16', label: '150名以上' },
  ],
};

export const PAGE_MAP = {
  [STATION_URL]: {
    step: '0',
    subStep: null,
    url: STATION_URL,
    nextUrl: TYPE_URL,
    prevUrl: null,
    buttonType: BUTTON_NO_PREV,
    title: '就業先を入力してください。',
    subTitle: '※現時点の対象エリアは東京都、神奈川県、埼玉県、千葉県のみとなります。',
  },
  [TYPE_URL]: {
    step: '1',
    subStep: null,
    url: TYPE_URL,
    nextUrl: SKILL_URL,
    prevUrl: STATION_URL,
    buttonType: BUTTON_DEFAULT,
    title: '該当する業務内容を選んでください。',
  },
  [SKILL_URL]: {
    step: '2',
    subStep: null,
    url: SKILL_URL,
    nextUrl: COND_URL,
    prevUrl: TYPE_URL,
    buttonType: BUTTON_DEFAULT,
    title: '求める経験・スキルを選択してください。',
  },
  [COND_URL]: {
    step: '3',
    subStep: null,
    url: COND_URL,
    nextUrl: INFO_URL,
    prevUrl: SKILL_URL,
    buttonType: BUTTON_DEFAULT,
    title: '条件を選択してください。',
  },
  [INFO_URL]: {
    step: '4',
    subStep: null,
    url: INFO_URL,
    nextUrl: CONF_URL,
    prevUrl: COND_URL,
    buttonType: BUTTON_DEFAULT,
    title: '詳細情報を入力してください。',
  },
  [CONF_URL]: {
    step: '5',
    subStep: null,
    url: CONF_URL,
    nextUrl: THANKS_URL,
    prevUrl: INFO_URL,
    buttonType: BUTTON_SUBMIT,
    title: '入力内容を確認してください。',
  },
  [THANKS_URL]: {
    step: '6',
    subStep: null,
    url: THANKS_URL,
    nextUrl: LP_URL,
    prevUrl: CONF_URL,
    buttonType: BUTTON_BACKLP,
    title: 'ご依頼いただきありがとうございました。',
  },
  default: {
    step: '0',
    subStep: null,
    url: '/',
    nextUrl: '/',
    prevUrl: null,
    buttonType: BUTTON_DEFAULT,
    title: 'タイトルだよ',
  },
};

export const MEASURE_MAP = {
  EVENT_EKI_SELECT: {
    name: 'Jobマ!駅選択',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,prop37,eVar37,prop54,eVar54',
    eVar37: 'D=c37',
  },
};

export const PROGRESS_LIST = [
  { pStep: '0', pTitle: '就業先', pTitleSp: [ '就業先' ] },
  { pStep: '1', pTitle: '業務内容', pTitleSp: [ '業務内容' ] },
  { pStep: '2', pTitle: '経験・スキル', pTitleSp: [ '経験・スキル' ] },
  { pStep: '3', pTitle: '条件', pTitleSp: [ '条件' ] },
  { pStep: '4', pTitle: '詳細情報', pTitleSp: [ '詳細情報' ] },
];

// はてなの文言
export const hatenaTextList = {
  oneSuggestSalary: [ '1時間あたりの請求額：勤務エリア×スキルで平均相場を自動算出しています' ],
  twoSuggestSalary: [ '1時間あたりの請求額：', '勤務エリア×スキルで平均相場を自動算出しています' ],
};

// debug, storybook用のダミーパラメータ
export const debugInitialState = {
  // station
  ekiCd: '22828',
  ekiName: '東京',
  moveTypeCd: '1',
  moveTime: '5', // post integer
  moveTimeFromBusStop: '',
  // order
  physicalCare: [ '01', '02', '03', '04', '05' ],
  lifeSupport: [ '01', '02', '03', '04', '05' ],
  otherWorkText: 'その他の業務内容です',
  // skill
  experience: '01',
  qualification: [ '01', '02', '03', '04', '05' ],
  qualificationText: 'これは介護資格の手入力欄です。',
  suggestHourSalary: 1300,
  // cond
  // fromDate: null,
  // toDate: null,
  // dayOfTheWeek: [],
  // startHour: '',
  // startMin: '',
  // endHour: '',
  // endMin: '',
  // restTime: '',
  // businessDay: '',
  // minOverTime: '',
  // maxOverTime: '',
  // hourSalary: '',
  fromDate: new Date('2020/01/01'), // post string
  pendingFromDateFlag: false,
  toDate: new Date('2021/12/31'), // post string
  pendingFromToFlag: false,
  minBusinessDay: '5', // post integer
  maxBusinessDay: '5', // post integer
  dayOfTheWeek: [ // post Array[integer]
    '0',
    '1',
    '2',
    '3',
    '6',
  ],
  workStyle: '02', // 勤務形態
  workStyleKbn: [ '02', '03', '04', '05' ], // シフト区分 
  earlyShiftStartHour: '09', // 早番
  earlyShiftStartMin: '00',
  earlyShiftEndHour: '18',
  earlyShiftEndMin: '00',
  earlyShiftRestTime: '60',
  dayShiftStartHour: '09', // 日勤
  dayShiftStartMin: '00',
  dayShiftEndHour: '18',
  dayShiftEndMin: '00',
  dayShiftRestTime: '60',
  lateShiftStartHour: '09', // 遅番
  lateShiftStartMin: '00',
  lateShiftEndHour: '18',
  lateShiftEndMin: '00',
  lateShiftRestTime: '60',
  nightShiftStartHour: '09', // 夜勤
  nightShiftStartMin: '00',
  nightShiftEndHour: '18',
  nightShiftEndMin: '00',
  nightShiftRestTime: '60',
  fixedStartHour: '08', // post startTime: '08:30' // 固定勤務
  fixedStartMin: '30', // post startTime: '08:30'
  fixedEndHour: '17', // post endTime: '17:00'
  fixedEndMin: '00', // post endTime: '17:00'
  fixedRestTime: '60', // post integer
  canCommuteByCar: '01', 
  hourSalary: '2500', // post integer
  freeComment: 'その他条件のコメント',

  // info
  // corpName: '',
  // userName: '',
  // tel: '',
  // email: '',
  corpName: 'リクルートスタッフィング',
  facilityName: 'Jobマ!ホーム',
  userName: '田中太郎',
  tel: '09011112222',
  email: 'nttd-sol@r-staffing.co.jp',
  facilityType: [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11' ],
  capacity: '01',
  zip: '111-3333',
  municipality: '東京都中央区銀座８丁目',
  houseNumber: '４−１７ リクルートGINZA8ビル',

  // valid TODO: false
  validMap: {
    [STATION_URL]: true,
    [TYPE_URL]: true,
    [SKILL_URL]: true,
    [COND_URL]: true,
    [INFO_URL]: true,
  },
  isRegistered: false,
  hourSalaryLoading: true,
};
export const MOVE_CONF_MSG = '他のページに移動しますか？入力したデータは保存されません。';